import { saveCollectionFormResponses } from '../network/api';
import { getCollectionFormDefinition } from '../network/api';

import { getVisibilityDictionary, clearHiddenComponentValues } from '../components/ComponentUtils';

import moment from 'moment';
import * as Sentry from '@sentry/browser'

export default {
    async updateResearchStudyGroupId({ commit, state, dispatch }, data) {
        if (state.researchStudyGroupId !== data) {
            commit('updateResearchStudyGroup', data);

            let response = null;
            try {
                response = await getCollectionFormDefinition(data);
            }
            catch (error) {
                commit('setErrorLoadingCollectionForm', true);

                if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);

                    commit('setErrorStatus', error.response.status);
                }
                else {
                    commit('setErrorStatus', -1);
                    Sentry.captureException(error);
                }
            }

            commit('updateLoadingApplication', false);

            if (response !== null) {
                let collectionForm = response.data;

                commit('setPages', collectionForm.pages)
                commit('setComputedVariables', collectionForm.variables);
                commit('setGlobalLabels', collectionForm.globalLabels);
                commit('updateCollectionFormId', collectionForm.collectionFormId);
                commit('updateCollectionFormStatus', collectionForm.collectionFormStatus);
                commit('updateCountryConfigurations', collectionForm.countryConfigurations);
                commit('updateCollectionFormLanguages', collectionForm.collectionFormLanguages);
                commit('setPreProduction', collectionForm.preProduction);

                if (collectionForm.gtmContainerId) {
                    try {
                        (function (w, d, s, l, i) {
                            w[l] = w[l] || []; w[l].push({
                                'gtm.start':
                                    new Date().getTime(), event: 'gtm.js'
                            }); var f = d.getElementsByTagName(s)[0],
                                j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
                                    'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
                        })(window, document, 'script', 'dataLayer', collectionForm.gtmContainerId);
                    }
                    catch (err) {
                        console.error('Error while initializing GTM', err);
                    }
                }

                dispatch('updateCollectionFormLanguageValues');

                dispatch('updateCalculatedVariables');
            }
        }
    },
    async saveResponse({ commit, state, getters, dispatch }, data) { // eslint-disable-line
        commit('updateVariablesLocal', {
            variableName: 'localEndTime',
            newValue: moment(new Date()).format()
        })

        // Get a dictionary of all elements and their visibility before the change is made
        const visibilityDictionaryPrevious = getVisibilityDictionary(state.pageList);

        if (Array.isArray(data)) {
            for (const row of data) {
                commit('updateResponseLocal', row);

                commit('updateVariablesLocal', {
                    variableName: 'lastQuestionAnswered',
                    newValue: row.variableName
                });
            }
        }
        else {
            commit('updateResponseLocal', data);

            commit('updateVariablesLocal', {
                variableName: 'lastQuestionAnswered',
                newValue: data.variableName
            });
        }

        dispatch('updateCalculatedVariables');

        // Get a dictionary of all elements and their visibility AFTER the change is made
        const visibilityDictionaryPost = getVisibilityDictionary(state.pageList);

        // For any elements that were visible previously, but now are not, clear out the associated value
        clearHiddenComponentValues(visibilityDictionaryPrevious, visibilityDictionaryPost, 0);

        await saveCollectionFormResponses(state.collectionFormId, state.sessionId, getters.leadStatus, state.responses, state.variables);
    },
    async triggerSave({ state, getters }) {
        await saveCollectionFormResponses(state.collectionFormId, state.sessionId, getters.leadStatus, state.responses, state.variables);
    },
    async updateLeadStatus({ commit, state, getters }, data) {
        if (state.leadStatus != data) {
            commit('updateLeadStatus', data);
            await saveCollectionFormResponses(state.collectionFormId, state.sessionId, getters.leadStatus, state.responses, state.variables);
        }
    },
    updateCalculatedVariables({ commit, dispatch, state, getters }) {
        if (state.computedVariables) {
            let responses = getters.responsesByVariableName; //eslint-disable-line
            let variables = getters.variables; //eslint-disable-line

            let collectionFormLanguageCalculated = false;

            state.computedVariables.forEach(row => {
                try {
                    let result = eval(row.formula);
                    commit('updateVariablesLocal', {
                        variableName: row.variableName,
                        newValue: result
                    });

                    if (row.variableName == 'language') {
                        collectionFormLanguageCalculated = true;
                    }
                }
                catch (err) {
                    console.error('Error while computing variable ' + row.name + ': ' + err);
                }
            });

            if (collectionFormLanguageCalculated) {
                // If there is a calculated variable that could change the language from what was originally passed in the URL,
                // re-run the collection form language values logic that updates the Language Name, Code and ID in the collection form variables.
                dispatch('updateCollectionFormLanguageValues');
            }

        }
    },
    updateCollectionFormLanguageValues({ commit, getters }) {
        const collectionFormLanguages = getters.collectionFormLanguages;
        if (collectionFormLanguages) {
            let foundLanguage = false;
            let language = getters.currentLanguage;
            for (const collectionFormLanguage of collectionFormLanguages) {
                if (collectionFormLanguage.language === language || (collectionFormLanguage.language === 'English' && language === 'English-US')) {
                    foundLanguage = true;

                    commit('updateVariablesLocal', {
                        variableName: 'collectionFormLanguageName',
                        newValue: collectionFormLanguage.language
                    })

                    commit('updateVariablesLocal', {
                        variableName: 'collectionFormLanguageCode',
                        newValue: collectionFormLanguage.languageCode
                    })

                    commit('updateVariablesLocal', {
                        variableName: 'collectionFormLanguageId',
                        newValue: collectionFormLanguage.sfid
                    })

                    if (collectionFormLanguage.rightToLeft) {
                        console.log('RTL Language enabled');
                        commit('updateRtlStatus', true);
                    }
                }
            }

            if (!foundLanguage) {
                commit('setBadLanguageParameter');
            }
        }
    }
}
